// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import PowerFlowPage from '../site-sections/power-flow/PowerFlowPage';
import SiteTabs from '../../components/shell/SiteTabs';

/**
 * Site → Power Flow. The page reads :site_id from the route and owns its own
 * data wiring (useDigitalTwin); this wrapper only supplies the Carbon shell
 * page frame.
 */
export default function SitePowerFlow() {
  return (
    <div className="hs-screen">
      <SiteTabs />
      <div className="hs-screen-body hs-screen-body--fill">
        <PowerFlowPage />
      </div>
    </div>
  );
}
